import {
  ResponsiveTable,
  ResponsiveTableBody,
  ResponsiveTableCell,
  ResponsiveTableHead,
  ResponsiveTableHeader,
  ResponsiveTableRow,
} from "@/components/ui/responsive-table";
import { Skeleton } from "@/components/ui/skeleton";

export const ActiveBidsTableSkeleton = () => {
  return (
    <div className="rounded-md border">
      <ResponsiveTable className="text-muted-foreground">
        <ResponsiveTableHeader>
          <ResponsiveTableRow>
            <ResponsiveTableHead>Name</ResponsiveTableHead>
            <ResponsiveTableHead>Company</ResponsiveTableHead>
            <ResponsiveTableHead>Event Date</ResponsiveTableHead>
            <ResponsiveTableHead>Status</ResponsiveTableHead>
            <ResponsiveTableHead className="text-right">
              Actions
            </ResponsiveTableHead>
          </ResponsiveTableRow>
        </ResponsiveTableHeader>
        <ResponsiveTableBody>
          {[1, 2, 3, 4, 5].map((i) => (
            <ResponsiveTableRow key={i}>
              <ResponsiveTableCell
                mobileLabel="Contact Name"
                mobilePriority="high"
              >
                <Skeleton className="h-4 w-[150px]" />
              </ResponsiveTableCell>
              <ResponsiveTableCell mobileLabel="Company" mobilePriority="high">
                <Skeleton className="h-4 w-[180px]" />
              </ResponsiveTableCell>
              <ResponsiveTableCell
                mobileLabel="Event Date"
                mobilePriority="medium"
              >
                <Skeleton className="h-4 w-[160px]" />
              </ResponsiveTableCell>
              <ResponsiveTableCell mobileLabel="Status" mobilePriority="medium">
                <Skeleton className="h-6 w-[100px] rounded-full" />
              </ResponsiveTableCell>
              <ResponsiveTableCell className="text-right">
                <Skeleton className="h-8 w-[80px] ml-auto" />
              </ResponsiveTableCell>
            </ResponsiveTableRow>
          ))}
        </ResponsiveTableBody>
      </ResponsiveTable>
    </div>
  );
};
